/* LYVN Diwali - cart drawer "You may also like" slider.
   The row is overflow:clip (see diwali-cart.css), so it is NOT a scroll
   container: the mouse wheel and the vertical touch drag always pass through
   to the cart drawer. Paging is done here, by moving the track with transform.
   The theme's own arrow handler is cancelled in the capture phase. */
(function () {
  'use strict';

  var SLIDER = '#Cart-Drawer .lyvn-cart-recommendations';
  var STEP   = 0.82;           /* how much of the visible width one tap moves */

  function all() { return document.querySelectorAll(SLIDER); }

  function parts(s) {
    return {
      view:  s.querySelector('.lyvn-cart-recommendations__scroll'),
      track: s.querySelector('.lyvn-cart-recommendations__track'),
      prev:  s.querySelector('.lyvn-cart-recommendations__arrow--prev'),
      next:  s.querySelector('.lyvn-cart-recommendations__arrow--next')
    };
  }

  function maxOffset(p) {
    var w = 0;
    var kids = p.track.children;
    for (var i = 0; i < kids.length; i++) w += kids[i].getBoundingClientRect().width;
    var gap = parseFloat(getComputedStyle(p.track).columnGap || 0) || 0;
    if (kids.length > 1) w += gap * (kids.length - 1);
    return Math.max(0, Math.round(w - p.view.clientWidth));
  }

  function setDisabled(btn, want) {
    if (btn && btn.disabled !== want) btn.disabled = want;
  }

  function setClass(el, cls, want) {
    if (!el) return;
    if (want && !el.classList.contains(cls)) el.classList.add(cls);
    else if (!want && el.classList.contains(cls)) el.classList.remove(cls);
  }

  /* idempotent: writing the same values again produces no mutation records,
     so the observer below cannot loop */
  function apply(s, want, animate) {
    var p = parts(s);
    if (!p.view || !p.track) return;

    var max = maxOffset(p);
    var off = Math.min(Math.max(0, Math.round(want)), max);

    var css = 'translate3d(' + (-off) + 'px,0,0)';
    if (p.track.style.transform !== css) {
      if (animate === false) p.track.style.transition = 'none';
      p.track.style.transform = css;
    }
    if (p.track.dataset.dwOffset !== String(off)) p.track.dataset.dwOffset = off;
    if (animate === false) {
      /* force a reflow so the next move animates again */
      void p.track.offsetWidth;
      p.track.style.transition = '';
    }

    /* write only on a real change - re-setting an attribute to the same value
       still fires the MutationObserver below and would loop forever */
    setDisabled(p.prev, off <= 1);
    setDisabled(p.next, off >= max - 1);
    setClass(s, 'lyvn-cart-recommendations--can-scroll', max > 8);
  }

  function offsetOf(s) {
    var t = s.querySelector('.lyvn-cart-recommendations__track');
    return t ? (parseFloat(t.dataset.dwOffset) || 0) : 0;
  }

  function page(s, dir) {
    var p = parts(s);
    if (!p.view) return;
    var step = Math.max(140, Math.round(p.view.clientWidth * STEP));
    apply(s, offsetOf(s) + step * dir, true);
  }

  function sync(animate) {
    all().forEach(function (s) {
      var t = s.querySelector('.lyvn-cart-recommendations__track');
      if (!t) return;
      /* a freshly rendered track has no stored offset -> start at 0 */
      apply(s, parseFloat(t.dataset.dwOffset) || 0, animate !== false ? undefined : false);
    });
  }

  /* capture phase: stops the theme's document-level handler from also
     calling scrollBy() on a row that can no longer scroll */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('#Cart-Drawer .lyvn-cart-recommendations__arrow');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var s = btn.closest('.lyvn-cart-recommendations');
    if (s) page(s, btn.classList.contains('lyvn-cart-recommendations__arrow--prev') ? -1 : 1);
  }, true);

  /* the theme re-computes the arrows after every cart refresh and, because the
     row no longer scrolls, disables both - put them back */
  var pending = false;
  var observer = new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; sync(false); });
  });

  function start() {
    var drawer = document.getElementById('Cart-Drawer');
    if (!drawer) return false;
    observer.observe(drawer, {
      childList: true, subtree: true,
      attributes: true, attributeFilter: ['disabled', 'class']
    });
    sync(false);
    return true;
  }

  function boot() {
    if (start()) return;
    var tries = 0;
    var timer = setInterval(function () {
      if (start() || ++tries > 40) clearInterval(timer);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('cart:refresh', function () { setTimeout(function(){ sync(false); }, 60); });

  var rt;
  window.addEventListener('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(function () { sync(false); }, 150);
  });
})();

/* ---- Diwali flying lanterns inside the cart drawer (every page) ---- */
(function () {
  if (window.__dwFlyDrawer) return;
  if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  window.__dwFlyDrawer = true;

  var css = document.createElement('style');
  css.textContent =
    '#Cart-Drawer .dw-fly-drawer{position:absolute;inset:0;z-index:50;pointer-events:none;overflow:hidden}' +
    '#Cart-Drawer .dw-fly-drawer i{position:absolute;bottom:-60px;width:20px;height:27px;border-radius:40% 40% 30% 30%;' +
    'background:radial-gradient(circle at 50% 60%,#FFE08A,#FF8A1F 55%,#C2410C);' +
    'box-shadow:0 0 20px 5px rgba(255,138,31,.35);opacity:.55;animation:dwFlyDrawer linear infinite;will-change:transform}' +
    '@keyframes dwFlyDrawer{0%{transform:translate(0,0)}50%{transform:translate(14px,-55vh)}100%{transform:translate(-8px,-115vh);opacity:0}}';
  document.head.appendChild(css);

  function layer() {
    var el = document.createElement('div');
    el.className = 'dw-fly-drawer';
    el.setAttribute('aria-hidden', 'true');
    var html = '';
    for (var j = 0; j < 5; j++) {
      html += '<i style="left:' + (6 + Math.random() * 84).toFixed(2) + '%;animation-duration:' +
        (14 + Math.random() * 10).toFixed(1) + 's;animation-delay:-' + (Math.random() * 20).toFixed(1) + 's"></i>';
    }
    el.innerHTML = html;
    return el;
  }

  function ensure(drawer) {
    if (!drawer.querySelector(':scope > .dw-fly-drawer')) drawer.appendChild(layer());
  }

  function start() {
    var drawer = document.getElementById('Cart-Drawer');
    if (!drawer) return false;
    ensure(drawer);
    /* the theme re-renders the drawer after cart changes - put the lanterns back */
    new MutationObserver(function () { ensure(drawer); }).observe(drawer, { childList: true });
    return true;
  }

  if (!start()) {
    var tries = 0;
    var t = setInterval(function () { if (start() || ++tries > 40) clearInterval(t); }, 250);
  }
})();